var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_393",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28883",
    "data-name": "Group 28883",
    transform: "translate(-4773 6306)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4773, -6306)",
    filter: "url(#Ellipse_393)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_393-2",
    "data-name": "Ellipse 393",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_10_",
    "data-name": "svgexport-17 (10)",
    transform: "translate(4791.365 -6289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49724",
    "data-name": "Path 49724",
    d: "M34.7,19.7,31.12,16.544l3.451-3.292a.488.488,0,0,0-.2-.822L29.774,11.1l1.7-4.445a.487.487,0,0,0-.079-.483A.493.493,0,0,0,30.933,6l-4.72.761-.384-4.739a.489.489,0,0,0-.279-.4.494.494,0,0,0-.49.039l-3.936,2.7L18.733.244a.493.493,0,0,0-.852,0L15.136,4.971l-4.748-2.74a.494.494,0,0,0-.492,0,.488.488,0,0,0-.247.423L9.639,7.407,4.873,7.014a.493.493,0,0,0-.445.209.486.486,0,0,0-.041.487l2.041,4.3L1.953,13.687a.488.488,0,0,0-.138.835l3.7,3.014L2.194,20.96a.488.488,0,0,0,.235.814L7.071,22.92,5.549,27.427a.487.487,0,0,0,.1.479.493.493,0,0,0,.466.156l4.687-.943.57,4.721a.489.489,0,0,0,.295.391.494.494,0,0,0,.488-.058l3.827-2.851,2.551,3.89a.493.493,0,0,0,.851-.033L21.609,29.1l4.039,2.546a.494.494,0,0,0,.491.02.489.489,0,0,0,.263-.413l.2-4.751,4.747.577a.493.493,0,0,0,.452-.191.487.487,0,0,0,.06-.485l-1.87-4.376,4.537-1.5A.488.488,0,0,0,34.7,19.7Z",
    transform: "translate(0 0)",
    fill: "#ffa600"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_396",
    "data-name": "Ellipse 396",
    cx: 10.128,
    cy: 10.12,
    rx: 10.128,
    ry: 10.12,
    transform: "translate(8.013 6.514)",
    fill: "#ffdb2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49725",
    "data-name": "Path 49725",
    d: "M243.565,99.743q-.381,0-.754.028a10.12,10.12,0,0,1,0,20.185q.373.027.754.028a10.12,10.12,0,1,0,0-20.241Z",
    transform: "translate(-225.424 -93.228)",
    fill: "#ffca00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.346a7cc104bc92044b41d3ba1eebe9df.svg";
export { ForwardRef as ReactComponent };